"use client";
import Link from "next/link";
import { AlertCircle, ArrowLeft } from "lucide-react";
import { useTranslations } from 'next-intl';

export default function ArticleError({
  errorMessage,
  displayButton
}: {
  errorMessage: string;
  displayButton: boolean
}) {
  const t = useTranslations('News');

  return (
    <div className={`min-h-[70vh] flex items-center justify-center px-6 ${displayButton ? 'bg-light' : ''}`}>
      <div className="max-w-md w-full text-center">
        <div className="mb-6 flex justify-center">
          <div className="p-4 bg-red-50 rounded-full">
            <AlertCircle className="w-12 h-12 text-red-500" />
          </div>
        </div>

        <h1 className={`text-3xl font-bold ${displayButton ? 'text-gray-900' : 'text-gray-200'} mb-4`}>
          {t('oops_article_error')}
        </h1>

        <p className="text-gray-600 mb-8">
          {errorMessage}
        </p>

        {displayButton && (
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              href="/blog"
              className="flex items-center justify-center gap-2 px-6 py-3 bg-dark text-white rounded font-semibold hover:bg-gray-200 transition-all"
            >
              <ArrowLeft size={18} />
              {t('back_blog')}
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}